module.exports = __webpack_public_path__ + "static/logo-linkedin-ce3c5449aa5c4331ae669f689123d6f6.png";